module.exports = __webpack_public_path__ + "img/alimini.8df3bb12.png";